export default __webpack_public_path__ + "static/media/handover-white.7d6fd7f6.svg";